import React from 'react';
import {isValidEmail} from "../Helpers";
import {submitLocationNotify} from "../Api";

const NotifyBox = (props) => {
    const [notifyEmail, setNotifyEmail] = React.useState('');
    const [emailError, setEmailError] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [submitted, setSubmitted] = React.useState(false);

    const {location} = props;
    const {t} = React.useContext(TranslationContext);

    const handleSubmit = async (e) => {
        if (submitting) {
            return;
        }

        e.preventDefault();
        if (!isValidEmail(notifyEmail)) {
            setEmailError(true);
            return;
        }
        setEmailError(false);
        setSubmitting(true);
        await submitLocationNotify({location_id: location.id, email: notifyEmail});
        setSubmitting(false);
        setSubmitted(true);
    }

    return <>
        <p className="mb-1">{t('location_free_notify_help')}</p>
        <div className="block mb-4">
            <label htmlFor="notify-email" className="is-fullwidth">{t('email_address')}</label>
            <input
                className="input email is-fullwidth"
                style={{borderWidth: '1px'}}
                type="email"
                id="notify-email"
                placeholder="ihre@e-mail.org"
                value={notifyEmail}
                onChange={(e) => setNotifyEmail(e.target.value)}/>
        </div>

        {!submitted && <div className="block mb-4">
            <button className="button is-fullwidth is-success" onClick={handleSubmit}>
                {t('subscribe_to_notify_list')}
            </button>
        </div>}

        {emailError && <div className="block mb-4 has-text-danger">
            <p>{t('invalid_email')}</p>
        </div>}
        {submitted && <div className="block mb-4 has-text-success">
            <p>{t('subscribe_to_notify_list_success')}</p>
        </div>}
    </>;
}

export default NotifyBox;
